import React from 'react';

class HierarchyErrorBoundary extends React.Component {
  // @ts-ignore
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: null };
  }
  // @ts-ignore
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }
  // @ts-ignore
  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log(error.message);
    //@ts-ignore
    if (!this.state.message) {
      switch (true) {
        case error.message.includes('missing'):
          this.setState({ message: 'An employee might be missing' });
          break;

        default:
          break;
      }
    }
  }

  render() {
    // @ts-ignore
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="hierarchy-container">
          <p>Your company`s employee data is not in the correct structure</p>
          {//@ts-ignore
          this.state.message && <p>{this.state.message}</p>}
        </div>
      );
    }

    return this.props.children;
  }
}
export default HierarchyErrorBoundary;
